import { css } from '@emotion/react'
import { Cell, Grid, Text } from 'bold-ui'
import { Fragment } from 'react'
import { CidadaoAtendimento } from 'view/atendimentos/types/CidadaoAtendimento'

import { AlergiaReacaoRow } from './AlergiaReacaoRow'
import { AlergiaReacaoModel } from './model'

export interface AlergiasReacoesTableProps {
  alergias: AlergiaReacaoModel[]
  cidadao: CidadaoAtendimento

  handleEditItem(values: AlergiaReacaoModel): void
  handleRemoveItem(item: AlergiaReacaoModel): void
}

export function AlergiasReacoesTable(props: AlergiasReacoesTableProps) {
  const { alergias, cidadao, handleRemoveItem, handleEditItem } = props

  return (
    /**
     * Nao utilizar o metodo de extensao isNotEmpty aqui, porque a prop alergias estah vindo como uma string vazia
     * para esse componente na primeira renderizacao
     * O problema estah no hook useEditableListField que retorna o input.value como any
     * A issue 11849 vai corrigir isso
     */
    alergias?.length > 0 && (
      <Fragment>
        <Grid
          style={css`
            margin: 0;
            padding: 0 1rem;
          `}
        >
          <Cell size={4}>
            <Text fontWeight='bold'>Categoria do agente causador</Text>
          </Cell>
          <Cell size={5}>
            <Text fontWeight='bold'>Agente ou substância específica</Text>
          </Cell>
        </Grid>
        {alergias.map(
          (item) =>
            item.isAvaliacao && (
              <AlergiaReacaoRow
                key={item._id}
                model={item}
                onChange={handleEditItem}
                onRemove={handleRemoveItem}
                cidadao={cidadao}
              />
            )
        )}
      </Fragment>
    )
  )
}
